import { Maybe } from 'maybe-not';
import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';
import { IDict } from '../types/utility';

export default function closeOverpanel(platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('closeOverpanel')) {
        return;
    }

    return function(resolutionData?: IDict<any>): void {
        sendMessage('closeOverpanel', Maybe.maybe(resolutionData).map(JSON.stringify));
    };
}
